import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders, thriweDiscoveryUrl } from '../../../../../../Containers/Config/index.js';
import { CREATE_SURGE_TEMPLATE, CREATE_SURGE_TEMPLATE_SUCCESS, CREATE_SURGE_TEMPLATE_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';

function* createSurgeTemplate({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-templates`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: payload?.data,
    });

    if (response.status === 201) {
      yield put({
        type: CREATE_SURGE_TEMPLATE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CREATE_SURGE_TEMPLATE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_SURGE_TEMPLATE_ERROR, payload: error });
  }
}

export function* watchcreateSurgeTemplate() {
  yield takeEvery(CREATE_SURGE_TEMPLATE, createSurgeTemplate);
}

function* createSurgeTemplateSaga() {
  yield all([fork(watchcreateSurgeTemplate)]);
}

export default createSurgeTemplateSaga;
